import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.to-string.js";
export function linkMyCalendar(provider, authorisationAction) {
  var params = new URLSearchParams({
    authorisationAction: authorisationAction
  });
  var url = "/api/me/calendar/".concat(provider, "/auth?").concat(params.toString());
  window.open(url, '_blank', 'noopener');
}